const itIT = {
    messages: {
        datatable: {
            matchMode: {
                startsWith: 'Inizia con',
                contains: 'Contiene',
                notContains: 'Non contiene',
                endsWith: 'Finisce con',
                equals: 'Uguale a',
                notEquals: 'Diverso da',
                in: 'In',
                lessThan: 'Minore di',
                lessThanOrEqual: 'Minore o uguale a',
                greaterThan: 'Maggiore di',
                greaterThanOrEqual: 'Maggiore o uguale a',
                between: 'Compreso tra',
                dateIs: 'Data uguale a',
                dateIsNot: 'Data diversa da',
                dateBefore: 'Data precedente',
                dateAfter: 'Data successiva'
            }
        },
        common: {
            name: 'Nome',
            description: 'Descrizione',
            title: 'Titolo',
            status: 'Stato',
            enabled: 'Attivo',
            disabled: 'Disattivato',
            enable: 'Abilita',
            disable: 'Disabilita',
            save: 'Salva',
            delete: 'Elimina',
            cancel: 'Annulla',
            create: 'Crea',
            add: 'Aggiungi',
            close: 'Chiudi',
            actions: 'Azioni',
            attention: 'Attenzione',
            loading: 'Caricamento...',
            error: 'Si è verificato un errore',
            noData: 'Nessun dato trovato',
            noTitle: 'Senza titolo',
            search: 'Cerca',
            clear: 'Pulisci',
            today: 'Oggi',
            tomorrow: 'Domani',
            yes: 'Sì',
            no: 'No',
            confirm: 'Conferma',
            continue: 'Continua',
            apply: 'Applica',
            unknown: 'Sconosciuto',
            edit: 'Modifica',
            saved: 'Salvataggio',
            deleted: 'Eliminato',
            success: 'Operazione completata con successo'
        },
        languages: {
            'it-IT': 'Italiano',
            'en-GB': 'Inglese'
        },
        filters: {
            title: 'Filtri',
            clear: 'Pulisci filtri',
            calendar: {
                reservationType: 'Tipo di prenotazione',
                reservationTypes: {
                    internal: 'Solo ad uso interno',
                    external: 'Solo visite clienti'
                },
                selectReservationType: 'Seleziona tipo di prenotazione',
                resourceTypes: 'Tipologie spazi',
                selectResourceTypes: 'Seleziona tipologie spazi',
                resources: 'Spazi',
                selectResources: 'Seleziona spazi',
                visitorType: 'Tipo cliente',
                selectVisitorTypes: 'Seleziona tipo cliente',
                onlyMyReservations: 'Visualizza solo le mie prenotazioni',
                showMaintenance: 'Mostra manutenzioni'
            }
        },
        calendar: {
            title: 'Calendario',
            searchCustomerCode: 'Ricerca cliente codificato',
            searchCustomerCodePlaceholder: 'Inserisci codice cliente o nominativo...',
            searchCustomerCodeHelp: 'Inizia a digitare per cercare un cliente codificato nel sistema AS400',
            unconfirmedTooltip: 'Visita passata non confermata',
            preview: {
                resource: 'Spazio',
                otherResources: '+{count} altro spazio | +{count} altri spazi',
                owner: 'Creato da',
                visitor: 'Cliente',
                attendees: 'Partecipanti',
                notes: 'Note',
                description: 'Descrizione',
                maintenance: 'Manutenzione',
                reducedCapacity: 'Capacità ridotta',
                untitled: 'Senza titolo'
            },
            timezone: {
                browserLocalTime: 'Ora del tuo browser',
                differsAria: 'Questo spazio usa un fuso orario diverso dal tuo',
                unknown: 'Fuso orario non riconosciuto',
                unknownDetail: 'Fuso orario dello spazio non riconosciuto: gli orari sono mostrati nel fuso del browser.'
            },
            changeConfirm: {
                title: 'Conferma {type}',
                move: 'spostamento',
                resize: 'ridimensionamento',
                info: 'Dettagli prenotazione',
                titleField: 'Titolo',
                description: 'Descrizione',
                resource: 'Spazio',
                visitor: 'Cliente',
                noVisitor: 'Nessun visitatore',
                attendees: 'Partecipanti',
                timeSlot: 'Modifica slot temporale',
                oldSlot: 'Slot precedente',
                newSlot: 'Nuovo slot',
                duration: 'Durata',
                durationChange: 'Cambio durata',
                longer: 'più lunga',
                shorter: 'più breve',
                warning: 'Confermando questa modifica, la prenotazione verrà aggiornata immediatamente nel calendario e salvata nel sistema.',
                noChanges: 'Nessuna modifica da confermare',
                confirmAction: 'Conferma modifica',
                updateSuccess: 'Prenotazione aggiornata con successo'
            },
            edit: {
                title: 'Modifica prenotazione',
                update: 'Aggiorna prenotazione'
            },
            new: {
                title: 'Nuova prenotazione',
                subtitle: 'I campi contrassegnati con {char} sono obbligatori',
                mandatoryFieldsHint: 'I campi contrassegnati con {char} sono obbligatori',
                reservationDetails: 'Dettagli prenotazione',
                customerInfo: 'Informazioni cliente',
                resourcesAndSlots: 'Spazi e orari',
                internalResourceLimit: 'Per prenotazioni ad uso interno è possibile selezionare un solo spazio',
                reviewAndConfirm: 'Riepilogo e conferma',
                step: 'Passo {current} di {total}',
                prev: 'Precedente',
                next: 'Successivo',
                reservationType: {
                    title: 'Tipo di prenotazione',
                    visit: 'Visita cliente',
                    visitDesc: 'Prenotazione per visita clienti o visitatori professionisti',
                    internal: 'Uso interno',
                    internalDesc: 'Prenotazione per uso interno (riunioni, formazione, ecc.)'
                },
                reservation: {
                    title: 'Titolo',
                    titlePlaceholder: 'Inserisci il titolo della prenotazione',
                    description: 'Descrizione',
                    descriptionPlaceholder: 'Inserisci una descrizione (opzionale)',
                    attendees: 'Numero partecipanti',
                    notes: 'Note aggiuntive',
                    notesPlaceholder: 'Inserisci eventuali note...'
                },
                visitors: {
                    title: 'Cliente',
                    noVisitors: 'Nessun cliente selezionato',
                    add: 'Aggiungi cliente',
                    addEdit: 'Aggiungi cliente',
                    type: 'Tipo cliente',
                    selectType: 'Seleziona il tipo di cliente',
                    firstName: 'Nome',
                    firstNamePlaceholder: 'Inserisci il nome del cliente',
                    lastName: 'Cognome',
                    lastNamePlaceholder: 'Inserisci il cognome del cliente',
                    email: 'Email per invio invito',
                    emailPlaceholder: "Inserisci l'email del cliente",
                    emailHelperText: "L'email è necessaria per inviare l'invito alla prenotazione. Assicurati che sia corretta.",
                    details: 'Dettagli clienti professionisti',
                    country: 'Paese',
                    countryPlaceholder: 'Inserisci il paese',
                    commercialSegment: 'Settore di attività',
                    commercialSegmentPlaceholder: 'Inserisci il settore di attività',
                    functionary: 'Funzionario',
                    agent: 'Agente',
                    businessName: 'Ragione sociale',
                    role: 'Ruolo',
                    activitySector: 'Settore di attività',
                    representsPurchaseGroup: 'Rappresenta gruppo di acquisto'
                },
                resourcesSlots: {
                    resourceNotSelected: 'Spazio non selezionato',
                    slotNotSelected: 'Periodo non selezionato',
                    noSlotsAdded: 'Nessuno slot selezionata',
                    addAtLeastOneSlot: 'Seleziona almeno un slot per completare la prenotazione',
                    newSlot: 'Nuovo slot',
                    bookingSlot: 'Slot prenotazione',
                    cannotChangeResource: 'Non è possibile cambiare spazio dopo aver aggiunto uno slot',
                    selectResource: 'Seleziona spazio',
                    selectResources: 'Seleziona spazi',
                    defaultTime: 'Orario predefinito',
                    defaultTimeHint: 'Si applica a tutte gli spazi sottostanti. Puoi sovrascriverlo per singolo spazio.',
                    configureSlots: 'Configura slot',
                    customTime: 'Orario personalizzato',
                    addTimeSlot: 'Aggiungi orario',
                    addTimeSlotsForResource: 'Aggiungi uno o più orari per lo spazio selezionato',
                    addAnotherTimeSlot: 'Aggiungi un altro orario',
                    timezoneNotice: 'Gli orari sono espressi nel fuso orario dello spazio ({zone}).',
                    customFields: {
                        title: 'Campi personalizzati',
                        notes: 'Note',
                        notesPlaceholder: 'Aggiungi note opzionali...'
                    },
                    addSlot: {
                        title: 'Aggiungi slot',
                        resource: 'Spazio',
                        selectResource: 'Seleziona uno spazio',
                        noResourceAvailable: 'Nessuno spazio disponibile',
                        date: 'Data',
                        startDate: 'Data inizio',
                        endDate: 'Data fine',
                        startTime: 'Ora inizio',
                        endTime: 'Ora fine',
                        slotPlaceholder: 'Seleziona data e ora',
                        duration: 'Durata',
                        durationFormat: '{hours} {hourUnit} e {minutes} {minuteUnit}',
                        save: 'Salva slot',
                        datePlaceholder: 'Seleziona data',
                        timePlaceholder: 'Seleziona ora',
                        validation: {
                            resourceRequired: 'Seleziona uno spazio',
                            slotRequired: 'Seleziona data e ora di inizio e fine',
                            startEndRequired: 'Data e ora di inizio e fine sono obbligatorie',
                            dateRequired: 'La data è obbligatoria',
                            timeRequired: "L'ora è obbligatoria",
                            endAfterStart: "L'ora di fine deve essere successiva a quella di inizio",
                            overlapsReservation: "L'orario selezionato si sovrappone ad una prenotazione esistente",
                            overlapsMaintenance: "L'orario selezionato si sovrappone ad un periodo di manutenzione"
                        },
                        error: {
                            resourceRequired: 'Seleziona uno spazio',
                            slotRequired: 'Seleziona data e ora di inizio e fine',
                            slotInvalid: 'Periodo non valido',
                            slotOverlap: 'Lo slot selezionato si sovrappone ad un altro',
                            noResourcesAvailable: 'Nessuno spazio disponibile'
                        }
                    },
                    timeline: {
                        title: 'Disponibilità giornaliera',
                        noAvailability: 'Nessuna disponibilità per questo giorno',
                        available: 'Disponibile',
                        reservations: 'Prenotazioni',
                        maintenance: 'Manutenzione',
                        selected: 'Selezionato',
                        dateHint: 'Seleziona una data per vedere le disponibilità dello spazio',
                        selectResourceAndDateHint: 'Seleziona uno spazio e una data per vedere le disponibilità',
                        datesWithAvailability: 'Le date in blu hanno disponibilità configurata',
                        dragHint: 'Clicca e trascina sulla timeline per selezionare un orario',
                        maxCapacity: 'max {capacity}',
                        partialMaintenance: 'Manutenzione parziale'
                    }
                },
                summary: {
                    title: 'Riepilogo',
                    type: 'Tipo di prenotazione',
                    reservation: 'Titolo',
                    attendees: 'Partecipanti',
                    visitor: 'Cliente',
                    bookedSlots: 'Slot prenotati',
                    date: 'Data'
                },
                preview: {
                    totalDuration: 'Durata totale',
                    resources: 'Spazi',
                    today: 'Oggi',
                    tomorrow: 'Domani'
                },
                switchType: {
                    confirmTitle: 'Cambio tipo prenotazione',
                    confirmAccept: 'Conferma',
                    loseVisitorData: 'I dati del cliente inseriti verranno rimossi.',
                    loseSlotsData: 'Le prenotazioni interne supportano un solo spazio. Gli slot inseriti verranno rimossi.'
                },
                capacity: {
                    available: 'disponibili',
                    notEnoughSpace: 'Capacità insufficiente: richiesti {requested} posti, disponibili solo {available} su {total}',
                    checkError: 'Errore durante il controllo della capacità',
                    badgeAria: 'Capacità: {available} posti disponibili su {total}'
                },
                validation: {
                    titleRequired: 'Il titolo è obbligatorio',
                    descriptionTooLong: 'La descrizione non può superare i 255 caratteri',
                    attendeesRequired: 'Il numero di partecipanti deve essere maggiore di 0',
                    firstNameRequired: 'Il nome è obbligatorio',
                    lastNameRequired: 'Il cognome è obbligatorio',
                    emailRequired: "L'email è obbligatoria",
                    countryRequired: 'Il paese è obbligatorio',
                    commercialSegmentRequired: 'Il settore di attività è obbligatorio',
                    erpCustomerRequired: 'Seleziona un cliente codificato',
                    slotValidationError: 'Errore durante la validazione dello slot',
                    formInvalid: 'Compilazione incompleta',
                    formInvalidDetail: 'Completa tutti i campi obbligatori prima di salvare'
                },
                reservationsCreatedForEveryResource: 'Le prenotazioni verranno create per ogni spazio selezionato.',
                save: 'Salva prenotazione',
                error: {
                    create: 'Errore durante la creazione della prenotazione',
                    update: "Errore durante l'aggiornamento della prenotazione"
                }
            },
            detail: {
                title: 'Dettaglio prenotazione',
                info: 'Informazioni prenotazione',
                client: 'Dettagli cliente',
                resources: 'Spazi prenotati',
                notes: 'Note aggiuntive',
                createdBy: 'Creato da',
                notAvailable: 'Non disponibile',
                erpCode: 'Codice ERP',
                email: 'Email',
                purchaseGroup: 'Gruppo di acquisto',
                representsPurchaseGroup: 'Rappresenta gruppo di acquisto',
                commercialSegment: 'Settore di attività',
                country: 'Paese',
                functionary: 'Funzionario',
                agent: 'Agente',
                duration: 'Durata',
                notFound: 'Prenotazione non trovata',
                notFoundDetails: 'Impossibile recuperare i dettagli della prenotazione',
                deleteConfirmTitle: 'Conferma eliminazione',
                deleteConfirmMessage: 'Sei sicuro di voler eliminare questa prenotazione? Questa azione non può essere annullata.',
                unknown: 'Sconosciuto',
                rangeFormat: '{date} dalle {start} alle {end}',
                deleteSuccess: {
                    title: 'Prenotazione eliminata',
                    detail: 'La prenotazione è stata eliminata con successo'
                },
                deleteError: "Si è verificato un errore durante l'eliminazione della prenotazione",
                unconfirmedBanner: 'Questa visita è passata e non è stata confermata'
            }
        },
        visitor: {
            type: {
                nonProfessional: 'Privato / Non Professionista',
                newProfessional: 'Professionista (Nuovo)',
                erpProfessional: 'Professionista Codificato',
                unknown: 'Sconosciuto'
            }
        },
        resources: {
            title: 'Gestione spazi',
            name: 'Nome',
            namePlaceholder: 'Es. Sala meeting 1',
            searchByName: 'Cerca spazio per nome...',
            type: 'Tipo',
            selectType: 'Seleziona un tipo',
            location: 'Posizione',
            locationPlaceholder: 'Es. Piano 2, Ala Est',
            description: 'Descrizione',
            descriptionPlaceholder: 'Descrizione opzionale dello spazio...',
            timezone: 'Fuso orario',
            selectTimezone: 'Seleziona un fuso orario',
            capacity: 'Capacità (persone)',
            color: 'Colore',
            enableCapacity: 'Abilita gestione capacità',
            capacityHelp: 'Lasciare a 0 se non applicabile',
            capacityPlaceholder: 'Numero massimo di persone',
            weeklyHours: 'Ore settimanali',
            saveSuccess: 'Spazio salvato con successo',
            newResource: 'Nuovo spazio',
            newResourceDescription: 'Aggiungi un nuovo spazio al sistema',
            editResource: 'Modifica spazio',
            editResourceDescription: 'Modifica i dettagli dello spazio',
            deleteResource: 'Elimina spazio',
            deleteResourceConfirm: 'Conferma eliminazione dello spazio',
            deleteWarning: "Stai per eliminare definitivamente questo spazio.\nL'operazione non può essere annullata.",
            noResourcesFound: 'Nessuno spazio trovato',
            tabs: {
                general: 'Informazioni generali',
                availability: 'Disponibilità',
                customFields: 'Campi personalizzati'
            },
            customFields: {
                title: 'Associa campi personalizzati',
                description: 'Seleziona i campi personalizzati da associare a questo spazio ({count} selezionati)',
                searchPlaceholder: 'Cerca campo personalizzato...',
                noFields: 'Nessun campo disponibile',
                noFieldsDescription: 'Non ci sono campi personalizzati disponibili',
                noResults: 'Nessun risultato per la ricerca',
                select: 'Seleziona',
                selected: 'Selezionato',
                managementInfo: 'Gestione campi',
                managementDescription: 'Per creare nuovi campi personalizzati, utilizza la sezione "Campi personalizzati" dal menu principale.',
                pageReport: 'Mostrando {first} - {last} di {totalRecords} campi'
            },
            types: {
                SHOWROOM: 'Sala mostra',
                MUSEUM: 'Museo',
                PRODUCTION_FACILITY: 'Stabilimento produttivo',
                BOARD_ROOM: 'Sala consiglio',
                MEETING_ROOM: 'Sala meeting'
            },
            validation: {
                nameRequired: 'Il nome dello spazio è obbligatorio',
                typeRequired: 'Seleziona un tipo di spazio',
                timezoneRequired: 'Seleziona un fuso orario',
                capacityRequired: 'La capacità deve essere maggiore di 0',
                statusRequired: 'Seleziona uno stato'
            }
        },
        userGroups: {
            title: 'Gestione gruppi utenti',
            name: 'Nome gruppo',
            description: 'Descrizione',
            users: 'Utenti',
            notifications: 'Notifiche',
            new: 'Nuovo gruppo',
            newGroup: 'Nuovo gruppo',
            editGroup: 'Modifica gruppo',
            deleteGroup: 'Elimina gruppo',
            groupUsers: 'Utenti del gruppo',
            groupActive: 'Gruppo attivo',
            noUserGroupsFound: 'Nessun gruppo utenti trovato',

            // Tabs
            tabs: {
                general: 'Generale',
                users: 'Utenti',
                notifications: 'Notifiche'
            },

            // Descriptions
            createDescription: 'Crea un nuovo gruppo e configura utenti e notifiche',
            editDescription: 'Modifica gruppo, gestisci utenti e configura notifiche',
            deleteConfirmDescription: 'Conferma eliminazione del gruppo',
            selectUsersOptional: 'Seleziona gli utenti da aggiungere al gruppo (opzionale - puoi aggiungere utenti in seguito)',
            manageGroupUsers: 'Aggiungi o rimuovi utenti da questo gruppo',

            // Actions
            manageUsers: 'Gestisci utenti',
            manageNotifications: 'Gestisci notifiche',

            // Form fields
            namePlaceholder: 'Inserisci il nome del gruppo',
            descriptionPlaceholder: 'Inserisci una descrizione (opzionale)',
            nameRequired: 'Il nome del gruppo è obbligatorio',

            // User management
            user: 'utente',
            usersSelected: 'utenti selezionati',
            searchUsersPlaceholder: 'Cerca utenti per nome, cognome o email...',
            noUsersFound: 'Nessun utente trovato',
            noUsersInGroup: 'Nessun utente nel gruppo',
            addUsersToGetStarted: 'Aggiungi utenti per iniziare',
            selectAll: 'Seleziona tutti',
            deselectAll: 'Deseleziona tutti',

            // Notifications
            notificationsDescription: 'Configura le notifiche che questo gruppo riceverà per ogni tipo di spazio',
            resourcesConfigured: 'spazi configurati',
            configureNotificationsToGetStarted: 'Configura le notifiche per iniziare',
            addResourceType: 'Aggiungi tipo spazio',
            addResourceTypes: 'Aggiungi tipi spazio',
            selectResourceType: 'Seleziona tipo spazio',
            selectResourceTypes: 'Seleziona i tipi di spazio',
            configureNotifications: 'Configura quando ricevere le notifiche',
            onCreate: 'Nuova prenotazione',
            onUpdate: 'Aggiornamento prenotazione',
            onDelete: 'Annullamento prenotazione',
            onUnconfirmed: 'Non confermata',
            enableAllNotifications: 'Abilita tutte le notifiche',
            disabledAllNotifcations: 'Disabilita tutte le notifiche',
            associationActive: 'Associazione attiva',
            associationStatus: 'Stato associazione',
            noNotificationsConfigured: 'Nessuna notifica configurata',
            addResourceToStart: 'Seleziona uno o più tipi di spazio per iniziare',

            // Success/Error messages
            deleteWarning: "Stai per eliminare definitivamente questo gruppo.\nL'operazione non può essere annullata.",
            deleteSuccess: 'Gruppo eliminato con successo',
            deleteError: 'Impossibile eliminare il gruppo',
            createSuccess: 'Gruppo creato con successo',
            updateSuccess: 'Gruppo aggiornato con successo',
            usersUpdateSuccess: 'Utenti del gruppo aggiornati con successo',
            notificationsUpdateSuccess: 'Impostazioni notifiche salvate con successo',
            errorLoadingUsers: 'Si è verificato un errore durante il caricamento degli utenti',
            errorLoadingNotifications: 'Si è verificato un errore durante il caricamento delle notifiche',

            // Validation
            validation: {
                nameRequired: 'Il nome del gruppo è obbligatorio',
                statusRequired: 'Seleziona uno stato'
            },
            searchByName: 'Cerca gruppi per nome...',
            allCategories: 'Tutte le categorie'
        },

        dataApi: {
            title: 'Data API'
        },

        users: {
            title: 'Gestione utenti',
            username: 'Username',
            firstName: 'Nome',
            lastName: 'Cognome',
            searchByName: 'Cerca utenti per nome...',
            email: 'Email',
            role: 'Ruolo',
            selectRole: 'Seleziona un ruolo',
            type: 'Tipo utente',
            selectType: 'Seleziona tipo utente',
            edit: 'Modifica',
            editUser: 'Modifica utente',
            editUserDescription: "Modifica i dati dell'utente e il suo ruolo nel sistema",
            types: {
                user: 'Utente',
                admin: 'Amministratore',
                superAdmin: 'Amministratore di sistema',
                unknown: 'Sconosciuto'
            },
            new: {
                title: 'Nuovo utente',
                subtitle: 'I campi contrassegnati con {char} sono obbligatori'
            },
            saveSuccess: 'Utente salvato con successo'
        },
        userNotifications: {
            title: 'Notifiche utente',
            description: 'Gestione delle notifiche per tipo di spazio',
            noNotifications: 'Nessuna notifica configurata',
            noNotificationsDescription: 'Non ci sono notifiche configurate per questo utente',
            resourceType: 'Tipo spazio'
        },
        status: {
            title: 'Stato',
            select: 'Seleziona stato',
            unknown: 'Sconosciuto',
            filterByStatus: 'Filtra per stato',
            all: 'Tutti',
            planned: 'Pianificato',
            canceled: 'Annullato',
            completed: 'Completato',
            enable: 'Attivo',
            disable: 'Disattivato'
        },

        // Maintenance section
        maintenance: {
            title: 'Gestione manutenzioni',
            subtitle: 'Gestione dei periodi di manutenzione e disponibilità degli spazi',
            untitledSlot: 'Nuova manutenzione',
            changeSchedule: 'Programma manutenzione',
            scheduleFor: 'Programma manutenzione per',
            configuredSlots: 'Fasce di manutenzione configurate',
            untitled: 'Senza titolo',
            addSlot: 'Aggiungi fascia',

            // Period filters
            period: {
                label: 'Periodo',
                selectRange: 'Seleziona intervallo date',
                quick: 'Periodo rapido',
                thisMonth: 'Questo mese',
                nextMonth: 'Prossimo mese',
                next3Months: 'Prossimi 3 mesi',
                thisYear: "Quest'anno"
            },

            // Status
            status: {
                active: 'Attiva',
                upcoming: 'Programmata',
                completed: 'Completata'
            },

            // Stato spazio
            inMaintenance: 'In manutenzione',
            maintenanceScheduled: 'Manutenzione programmata',
            available: 'Disponibile',
            noMaintenance: 'Nessuna manutenzione programmata',
            resourceAvailable: 'Lo spazio è disponibile',

            // Timeline
            today: 'Oggi',
            total: 'Totale manutenzioni',

            // Delete
            delete: {
                title: 'Elimina manutenzione',
                message: 'Conferma eliminazione',
                warning: 'Questa azione non può essere annullata'
            },

            // Empty state
            empty: {
                title: 'Nessuna manutenzione programmata',
                subtitle: 'Inizia aggiungendo una nuova manutenzione'
            },
            noMaintenances: 'Nessuna manutenzione',
            noMaintenancesDesc: 'Nessuna manutenzione programmata per questo periodo',
            noSlots: 'Nessuna fascia',
            noSlotsDescription: 'Nessuna fascia di manutenzione programmata',
            noSlotsScheduled: 'Nessuna fascia programmata',
            clickAddToSchedule: 'Clicca su "Aggiungi fascia" per programmare una manutenzione',
            form: {
                slots: 'Fasce di manutenzione',
                slot: 'Fascia',
                addSlot: 'Aggiungi fascia',
                allDay: 'Tutto il giorno',
                title: 'Titolo',
                titlePlaceholder: 'Es. Manutenzione ordinaria',
                dayOfWeek: 'Giorno della settimana',
                selectDay: 'Seleziona giorno',
                timeRange: 'Fascia oraria',
                startTimePlaceholder: 'Inizio (HH:mm)',
                endTimePlaceholder: 'Fine (HH:mm)',
                validFrom: 'Valido dal',
                validFromPlaceholder: 'Data inizio validità',
                validUntil: 'Valido fino al',
                validUntilPlaceholder: 'Data fine validità',
                description: 'Descrizione',
                descriptionPlaceholder: 'Note aggiuntive...',
                blockingMode: 'Modalità di blocco',
                blockingModeFully: 'Blocco totale',
                blockingModePartial: 'Capacità ridotta',
                reducedCapacity: 'Capacità durante la manutenzione',
                reducedCapacityHint: 'Massimo {max} (capacità dello spazio)'
            },
            blockingMode: {
                fully: 'Blocco totale',
                partial: 'Capacità ridotta: {capacity}'
            },
            conflicts: {
                row: '{date} {start}–{end} · {attendees} partecipanti (max {cap})',
                more: '…e un altro | …e altri {count}'
            },
            validation: {
                resourceRequired: 'Lo spazio è obbligatorio',
                titleRequired: 'Il titolo è obbligatorio per tutte le fasce',
                timesRequired: 'Orario di inizio e fine sono obbligatori',
                endTimeAfterStartTime: "L'orario di fine deve essere successivo a quello di inizio",
                validUntilAfterValidFrom: 'La data di fine validità deve essere successiva a quella di inizio',
                saveFailed: 'Si è verificato un errore durante il salvataggio della manutenzione',
                loadFailed: 'Si è verificato un errore durante il caricamento dei dati',
                dayRequired: 'Seleziona un giorno della settimana',
                startTimeRequired: 'Inserisci un orario di inizio',
                endTimeRequired: 'Inserisci un orario di fine',
                endAfterStart: "L'orario di fine deve essere successivo all'inizio",
                reducedCapacityRequired: 'Inserisci la capacità ridotta',
                reducedCapacityRange: 'La capacità ridotta deve essere compresa tra 1 e {max}'
            }
        },
        settings: {
            language: 'Lingua',
            logout: 'Logout',
            profile: 'Profilo',
            poweredBy: 'Realizzato da'
        },
        auth: {
            loggingIn: 'Login in corso...'
        },

        // Common actions
        search: 'Cerca',
        close: 'Chiudi',
        edit: 'Modifica',
        delete: 'Elimina',
        cancel: 'Annulla',
        save: 'Salva',
        create: 'Crea',
        add: 'Aggiungi',
        yes: 'Sì',
        no: 'No',
        confirm: 'Conferma',
        continue: 'Continua',
        clearFilters: 'Pulisci filtri',
        actions: 'Azioni',
        attention: 'Attenzione',
        saved: 'Salvataggio',
        deleted: 'Eliminato',
        error: {
            title: 'Si è verificato un errore',
            updateUser: "Impossibile aggiornare l'utente",
            loadUsers: 'Si è verificato un errore durante il caricamento degli utenti',
            noDataFromServer: 'Nessun dato ricevuto dal server',
            deleteNotAllowed: 'Eliminazione non consentita',
            invalidTimeRange: "L'intervallo orario selezionato non è valido",
            tooDistant: 'La data selezionata è troppo lontana',
            resourceAlreadyBooked: 'Lo spazio è già prenotato per questa fascia oraria',
            resourceCapacityExceeded: 'La capacità massima dello spazio è stata superata',
            resourceUnderMaintenance: 'Lo spazio è attualmente in manutenzione',
            resourceCapacityReducedByMaintenance: 'La capacità dello spazio è ridotta da una manutenzione in questa fascia oraria',
            resourceWithoutAvailability: 'Lo spazio non ha disponibilità configurata',
            resourceAvailabilityNotFullyCovered: 'Lo slot selezionato non è interamente coperto dalla disponibilità dello spazio',
            maintenanceConflictsWithReservations: 'Impossibile salvare: alcune visite già prenotate superano la capacità ridotta',
            invalidReducedCapacity: 'La capacità ridotta non è valida per questo spazio',
            invalidTimezone: 'Il fuso orario indicato non è valido',
            overlapping: 'Lo slot selezionato si sovrappone ad un altro slot esistente'
        },
        errors: {
            generic: 'Si è verificato un errore inaspettato',
            saveFailed: 'Impossibile salvare i dati',
            http: 'Si è verificato un errore del server ({status})',
            saveSuccess: 'Dati salvati con successo',
            deleteSuccess: 'Elemento eliminato con successo'
        },
        loading: 'Caricamento...',

        // Custom fields
        customFields: {
            title: 'Campi personalizzati',
            new: 'Nuovo campo',
            edit: 'Modifica campo',
            delete: 'Elimina campo',
            titleField: 'Titolo del campo',
            description: 'Descrizione',
            email: 'Email referente',
            resources: 'Spazi',
            deleteWarning: "Stai per eliminare definitivamente questo campo personalizzato.\nL'operazione non può essere annullata.",
            noCustomFields: 'Nessun campo personalizzato trovato',
            noDescription: 'Nessuna descrizione',
            searchByTitle: 'Cerca per titolo...',
            allCategories: 'Tutte le categorie',
            saveSuccess: 'Campo personalizzato salvato con successo',
            validation: {
                titleRequired: 'Il titolo è obbligatorio',
                statusRequired: 'Seleziona uno stato'
            }
        },

        // Tipi spazio
        resourceTypes: {
            title: 'Tipi spazio',
            new: 'Nuovo tipo spazio',
            edit: 'Modifica tipo spazio',
            delete: 'Elimina tipo spazio',
            name: 'Nome',
            description: 'Descrizione',
            saveSuccess: 'Tipo spazio salvato con successo',
            deleteWarning: "Stai per eliminare definitivamente questo tipo di spazio.\nL'operazione non può essere annullata.",
            validation: {
                nameRequired: 'Il nome è obbligatorio'
            }
        },

        // Availability
        availability: {
            manage: 'Gestisci disponibilità',
            manageTitle: 'Gestisci disponibilità - {name}',
            configTitle: 'Configura gli orari di disponibilità',
            totalWeeklyHours: 'h',
            hoursPerWeek: 'ore/settimana',
            loading: 'Caricamento disponibilità...',
            infoTitle: 'Gestione disponibilità',
            infoDescription: 'Puoi creare fasce orarie standard (sempre valide) o personalizzate (con un periodo di validità). Nei giorni coperti da una fascia personalizzata valgono solo le fasce personalizzate: quelle standard vengono sostituite, non sommate. Lascia le date vuote per fasce sempre attive.',
            quickActions: 'Azioni rapide',
            weekdays: 'Giorni feriali',
            fullWeek: 'Settimana completa',
            clearAll: 'Cancella tutto',
            timeSlots: 'Fasce orarie ({count})',
            addSlot: 'Aggiungi fascia',
            days: {
                all: 'Tutti i giorni',
                monday: 'Lunedì',
                tuesday: 'Martedì',
                wednesday: 'Mercoledì',
                thursday: 'Giovedì',
                friday: 'Venerdì',
                saturday: 'Sabato',
                sunday: 'Domenica'
            },
            configureSlots: 'Configura fasce orarie',
            noSlots: 'Nessuna fascia oraria definita',
            noSlotsDescription: 'Clicca "Aggiungi fascia" o usa le azioni rapide per iniziare',
            slotType: {
                custom: 'Personalizzata',
                standard: 'Standard'
            },
            fields: {
                title: 'Titolo',
                titlePlaceholder: 'Es. Orario standard',
                description: 'Descrizione (opzionale)',
                descriptionPlaceholder: '',
                day: 'Giorno',
                selectDay: 'Seleziona giorno',
                start: 'Inizio',
                end: 'Fine',
                validFrom: 'Valido da (opzionale)',
                validUntil: 'Valido fino al (opzionale)',
                datePlaceholder: 'Sempre valido se vuoto'
            },
            duration: 'Durata',
            from: 'Dal',
            until: 'Al',
            validRange: '{start} - {end}',
            validFromDate: 'Dal {date}',
            validUntilDate: 'Fino al {date}',
            validation: {
                invalidTime: 'Formato orario non valido. Usa HH:MM (es. 09:00)',
                startBeforeEnd: "L'orario di inizio deve essere precedente a quello di fine",
                validFromBeforeUntil: 'La data di inizio validità deve essere precedente alla data di fine',
                saveSuccess: 'Disponibilità salvata con successo',
                loadError: 'Impossibile caricare i dati di disponibilità',
                saveError: 'Impossibile salvare la disponibilità. Riprova.',
                dayRequired: 'Seleziona un giorno',
                startRequired: 'Inserisci un orario di inizio',
                endRequired: 'Inserisci un orario di fine',
                endAfterStart: "L'orario di fine deve essere successivo all'inizio"
            },
            pendingDeletions: 'Eliminazioni in sospeso',
            deleteNoReservations: 'Sarà eliminato al salvataggio - nessuna prenotazione interessata',
            deleteWithReservations: 'Sarà eliminato al salvataggio - le prenotazioni correlate saranno annullate',
            reason: 'Motivo',
            undoDelete: 'Annulla',
            deleteSlotConfirm: {
                title: 'Elimina fascia oraria',
                warning: 'Questa fascia ha delle prenotazioni',
                hasReservations: 'Ci sono prenotazioni che dipendono da questa fascia oraria. Eliminandola verranno annullate tutte le prenotazioni interessate.',
                reasonLabel: "Motivo dell'annullamento",
                reasonPlaceholder: 'Spiega perché queste prenotazioni vengono annullate...',
                reasonHint: 'Questo motivo sarà comunicato ai clienti le cui prenotazioni vengono annullate.',
                proceed: 'Elimina e annulla prenotazioni'
            }
        },
        createReservation: {
            title: 'Nuova prenotazione',
            prompt: 'Inizia il processo di creazione della prenotazione',
            selectedSlot: 'Slot temporale selezionato',
            date: 'Data',
            time: 'Orario',
            duration: 'Durata',
            nextSteps: 'Prossimi passi',
            step1: 'Inserire titolo e dettagli della prenotazione',
            step2: 'Selezionare cliente e numero partecipanti',
            step3: 'Selezionare altri spazi da prenotare',
            loadingAvailability: 'Verifica disponibilità degli spazi...',
            noAvailableResources: 'Nessuno spazio disponibile per la fascia oraria selezionata'
        },
        cancelReservation: {
            title: 'Disdici prenotazione',
            confirm: 'Sei sicuro di voler annullare questa prenotazione?',
            message: 'Tutti gli spazi prenotati verranno liberati e resi disponibili per altre prenotazioni.',
            warning: "L'operazione non può essere annullata.",
            success: 'Prenotazione annullata con successo',
            error: "Si è verificato un errore durante l'annullamento della prenotazione"
        },
        confirmReservation: {
            title: 'Segna visita come avvenuta',
            confirm: 'Sei sicuro di voler confermare questa prenotazione?',
            message: 'La prenotazione verrà salvata e gli spazi saranno bloccati per il periodo selezionato.',
            success: 'Prenotazione confermata con successo',
            error: 'Si è verificato un errore durante la conferma della prenotazione'
        },
        // Time units
        time: {
            minute: 'minuto | minuti',
            hour: 'ora | ore',
            day: 'giorno | giorni',
            morning: 'Mattina',
            afternoon: 'Pomeriggio',
            evening: 'Sera'
        },
        menu: {
            reservations: 'Prenotazioni',
            calendar: 'Calendario',
            newReservation: 'Nuova prenotazione',
            resources: 'Spazi',
            maintenances: 'Manutenzioni',
            customFields: 'Campi personalizzati',
            users: 'Utenti',
            groups: 'Gruppi'
        },
        days: {
            all: 'Tutti i giorni',
            monday: 'Lunedì',
            tuesday: 'Martedì',
            wednesday: 'Mercoledì',
            thursday: 'Giovedì',
            friday: 'Venerdì',
            saturday: 'Sabato',
            sunday: 'Domenica'
        }
    }
};

export default itIT;
